module.exports = __webpack_public_path__ + "img/camera.5e2619c5.png";